export enum RateSource {
  /** Bloomberg */
  Bloomberg = 0,
  /** Reuters */
  Reuters = 1,
  /** Telerate */
  Telerate = 2,
  ISDARateOption = 3,
  /** Other */
  Other = 99,
}
